import type { TFeaturedIconColor } from "libs/design-system/src/types/featured_icon/featuredIcon";
import type { TModalState } from "libs/design-system/src/types/modal";

export const ICON_COLOR_MAPPER: Record<TModalState, TFeaturedIconColor> = {
  default: 'gray',
  success: 'green',
  warning: 'yellow',
  danger: 'red',
  primary: 'primary'
};
